import React, { useEffect, useState } from 'react';
import { supabase } from '../../../../supabaseClient'; // Ajuste o caminho do client se necessário
import HeroBanner from '../HeroBanner';
import CategoryRow from '../CategoryRow';

export default function InicioContent({ onSelectVideo, handleViewAll }: any) {
  const [loading, setLoading] = useState(true);
  const [bannerVideos, setBannerVideos] = useState<any[]>([]);
  const [maisAssistidos, setMaisAssistidos] = useState<any[]>([]);
  const [acao, setAcao] = useState<any[]>([]);
  const [aventura, setAventura] = useState<any[]>([]);
  const [terror, setTerror] = useState<any[]>([]);
  const [desenhos, setDesenhos] = useState<any[]>([]);
  const [hasContent, setHasContent] = useState(false);

  useEffect(() => {
    async function fetchInicioData() {
      setLoading(true);
      try {
        // 🚀 CONSULTAS PARALELAS AO SUPABASE: Puxa apenas o necessário para a página inicial (Início)
        // 🚀 CONSULTAS PARALELAS AO SUPABASE COM ORDENAÇÃO INTELIGENTE POR ENGAJAMENTO
        const [
          resBanner,
          resMaisAssistidos,
          resAcao,
          resAventura,
          resTerror,
          resDesenhos
        ] = await Promise.all([
          supabase.from('videos').select('*').not('is_short', 'eq', true).not('category', 'ilike', 'games%').order('created_at', { ascending: false }).limit(5),
          supabase.from('videos').select('*').not('is_short', 'eq', true).not('category', 'ilike', 'games%').order('likes_count', { ascending: false }).order('views_count', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.filmes:acao,category.ilike.acao').order('likes_count', { ascending: false }).order('views_count', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.filmes:aventura,category.ilike.aventura').order('likes_count', { ascending: false }).order('views_count', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.terror,category.ilike.suspense').order('likes_count', { ascending: false }).order('views_count', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.desenho,category.ilike.animacao').order('likes_count', { ascending: false }).order('views_count', { ascending: false }).limit(10),
        ]);

        const mAss = resMaisAssistidos.data || [];
        const ac = resAcao.data || [];
        const av = resAventura.data || [];
        const tr = resTerror.data || [];
        const dz = resDesenhos.data || [];

        setBannerVideos(resBanner.data || []);
        setMaisAssistidos(mAss);
        setAcao(ac);
        setAventura(av);
        setTerror(tr);
        setDesenhos(dz);

        setHasContent((mAss.length + ac.length + av.length + tr.length + dz.length) > 0);

      } catch (err) {
        console.error("Erro ao carregar dados da página inicial:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchInicioData();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px', color: '#888', fontSize: '16px' }}>
        Carregando página inicial...
      </div>
    );
  }

  return (
    <div>
      <HeroBanner videos={bannerVideos} onPlay={onSelectVideo} onInfo={onSelectVideo} />
      
      <div style={{ marginTop: '20px', position: 'relative', zIndex: 50 }}>
        {hasContent ? (
          <>
            {maisAssistidos.length > 0 && (
              <CategoryRow 
                title="🔥 Mais Assistidos" 
                videos={maisAssistidos} 
                onSelectVideo={onSelectVideo} 
                onViewAll={() => handleViewAll("🔥 Mais Assistidos", maisAssistidos)} 
              />
            )}
            
            {acao.length > 0 && (
              <CategoryRow 
                title="💥 Ação" 
                videos={acao} 
                onSelectVideo={onSelectVideo} 
                onViewAll={() => handleViewAll("💥 Ação", acao)} 
              />
            )}

            {aventura.length > 0 && (
              <CategoryRow 
                title="🗺️ Aventura" 
                videos={aventura} 
                onSelectVideo={onSelectVideo} 
                onViewAll={() => handleViewAll("🗺️ Aventura", aventura)} 
              />
            )}

            {terror.length > 0 && (
              <CategoryRow 
                title="👻 Terror & Suspense" 
                videos={terror} 
                onSelectVideo={onSelectVideo} 
                onViewAll={() => handleViewAll("👻 Terror & Suspense", terror)} 
              />
            )}

            {desenhos.length > 0 && (
              <CategoryRow 
                title="🎨 Desenhos & Animações" 
                videos={desenhos} 
                onSelectVideo={onSelectVideo} 
                onViewAll={() => handleViewAll("🎨 Desenhos & Animações", desenhos)} 
              />
            )}
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '100px', color: '#888' }}>
            Nenhum conteúdo disponível no momento.
          </div>
        )}
      </div>
    </div>
  );
}